import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { Hero } from './components/Hero';
import { Layout } from './components/Layout';
import { Terms } from './pages/Terms';
import { Privacy } from './pages/Privacy';
import { Contact } from './pages/Contact';
import { Careers } from './pages/Careers';
import { About } from './pages/About';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
export function App() {
  return <>
      <ScrollToTop data-id="element-0" />
      <Routes data-id="element-1">
        <Route path="/" element={<Layout data-id="element-3" />} data-id="element-2">
          <Route index element={<Hero data-id="element-5" />} data-id="element-4" />
          <Route path="terms" element={<Terms data-id="element-7" />} data-id="element-6" />
          <Route path="privacy" element={<Privacy data-id="element-9" />} data-id="element-8" />
          <Route path="contact" element={<Contact data-id="element-11" />} data-id="element-10" />
          <Route path="careers" element={<Careers data-id="element-13" />} data-id="element-12" />
          <Route path="about" element={<About data-id="element-15" />} data-id="element-14" />
        </Route>
      </Routes>
    </>;
}